<h1>Kunden</h1>
<table mat-table [dataSource]="allCustomers" class="mat-elevation-z8">
  <ng-container matColumnDef="id">
    <th class="small-header" mat-header-cell *matHeaderCellDef> ID</th>
    <td mat-cell *matCellDef="let element">
      <button cdkCopyToClipboard="{{element.id}}" mat-icon-button aria-label="Kopieren">
        <mat-icon>content_copy</mat-icon>
      </button>
      {{element.id.substring(0, 6)}}...
    </td>
  </ng-container>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef> Name</th>
    <td mat-cell *matCellDef="let element"> {{element.name}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<br>
<mat-paginator [length]="length"
               [pageSize]="pageSize"
               [pageSizeOptions]="[5, 10, 25, 100]"
               (page)="pageEvent = $event; onPaginateChange($event)">
</mat-paginator>

